var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ignore_address_coverage)?_c('FixedAlert',{attrs:{"top":_vm.top}},[_c('AlertIgnoreAddressText')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }